import { ExpertiseWidgetStrategy } from 'widgets/expertise/ExpertiseWidgetStrategy';
import { PortfolioSelectionRequirements } from 'widgets/PortfolioSelectionRequirements';
import { initialExpertiseConfiguration } from 'widgets/expertise/store/configuration/ExpertiseConfigurationState';

export const expertiseWidgetStrategyCommon: Pick<
    ExpertiseWidgetStrategy,
    | 'requiredAuthorities'
    | 'portfolioSelectionRequirements'
    | 'supportedHosts'
    | 'initialConfigState'
> = {
    requiredAuthorities: ['indigo.expertise'],
    supportedHosts: ['layout'],
    portfolioSelectionRequirements:
        PortfolioSelectionRequirements.AtLeastOneOrder,
    initialConfigState: initialExpertiseConfiguration,
};
